import {
  useActivePractice,
  useDispatch,
  usePracticeProperties,
} from '@witmetrics/data-store';
import { useNewCase } from '@/providers/NewCaseProvider';
import Divider from '@/components/Divider';
import Title from '@/components/Title';
import StepTitle from '@/dialogs/NewCaseDialog/steps/StepTitle';
import ExistingLeadForm from './ExistingLeadForm';
import NewLeadForm from './NewLeadForm';
import type { NewLeadData } from './types';
import { classes, createLead } from './utils';

export type PatientStepProps = {
  onSave: (leadId: number) => void;
};

export default function PatientStep({ onSave }: PatientStepProps) {
  const dispatch = useDispatch();
  const activePractice = useActivePractice();
  const properties = usePracticeProperties();
  const { leadId, onSelectLead } = useNewCase();

  const handleSave = async (data: NewLeadData) => {
    const lead = await createLead(activePractice!.id, properties, data);
    dispatch.addLeads([lead]);
    onSelectLead(lead.id);
    onSave(lead.id);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.column}>
        <Title size="xs">Select an Existing Patient</Title>
        <p className={classes.instructions}>
          Search by name, email, phone, or external ref.
        </p>
        <ExistingLeadForm leadId={leadId} onSelect={onSelectLead} />
      </div>
      <Divider flexItem className={classes.divider} orientation="vertical" />
      <div className={classes.column}>
        <StepTitle
          title="Create a New Patient"
          subtitle="Add a new patient to the case"
        />
        <NewLeadForm onSave={handleSave} />
      </div>
    </div>
  );
}
